<div class="bg-surface-dark-500 pt-16">
  <div class="container">
    <section class="md:flex md:justify-between md:items-center py-2 mb-8 max-md:text-center">
      <a href="/" class="btn-filled grad-ltd mr-3 max-md:mb-3 max-md:flex max-md:justify-center">
        <img width="164px" height="28px" src="./assets/images/logo-white.svg" />
      </a>
      <p class="text-gray-700">The top search platform in the US to discover franchise opportunities</p>
    </section>
    
    <section class="grid grid-cols-1 xxs:grid-cols-2 md:grid-cols-3 md:grid-cols-3 xl:grid-cols-6 py-[0.56rem] mb-8 max-xl:[&>div]:mb-3 [&_.h6]:text-white [&>div_.h6]:mb-8 [&_li]:text-white [&_li]:mb-4">
      <div *ngFor="let firstListItem of dummyData.slice(0, 3)">
        <h6 class="h6">{{firstListItem.key}}</h6>
        <ul *ngIf="firstListItem.items && firstListItem.items.length > 0">
          <li *ngFor="let item of firstListItem.items"><a [routerLink]="item.link">{{item.key}}</a></li>
        </ul>
      </div>
      <div class="xl:col-span-3" *ngIf="dummyData[dummyData.length - 1] as lastList">
        <h6 class="h6">{{lastList.key}}</h6>
        <ul *ngIf="lastList.items && lastList.items.length > 0" class="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <li *ngFor="let lastListItem of lastList.items">
            <a [routerLink]="lastListItem.link">{{lastListItem.key}}</a>
          </li>
        </ul>
      </div>
    </section>
    
    <div class="footer-bottom py-[1.69rem] before:content-[''] before:block before:h-px before:w-full before:bg-gradient-to-r before:from-stop1 before:to-stop2 relative before:absolute before:top-0 before:left-0 before:right-0">
      <div class="flex justify-between items-center">
        <div class="left-text text-gray-600 mr-auto">© 2022 Franbase. All Rights Reserved.</div>
        <div class="flex items-center [&>a]:flex [&>a]:items-center [&_a_svg-icon]:text-gray-700 hover:[&_a_svg-icon]:text-primary-500">
          <a routerLink="/"><svg-icon key="fbFooterIcon" fontSize="24px" class="mr-7"></svg-icon></a>
          <a routerLink="/"><svg-icon key="xFooterIcon" fontSize="24px" class="mr-7"></svg-icon></a>
          <a routerLink="/"><svg-icon key="igFooterIcon" fontSize="24px" class="mr-7"></svg-icon></a>
          <a routerLink="/"><svg-icon key="inFooterIcon" fontSize="24px" class="mr-7"></svg-icon></a>
        </div>
      </div>
    </div>
  </div>
</div>
